<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/arrow_left.png" alt="" class="logo" @click="back()">
            <span class="title">{{ $t("message.news") }}</span>
            <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
        </div>
        <div class="content">
            <div class="scrollCon">
                <div class="newsTitle" v-html="newsDetail.post_title">
                   
                </div>
                <div class="newsTimeCon">
                    <span v-show="newsDetail.published_time">{{newsDetail.published_time*1000|formatDate}}</span>
                </div>
                <div v-html="newsDetail.post_content" class="newsContent">
                </div>
            </div>
                
        </div>
        <mt-popup
        v-model="navbarShow" 
        position="right" class="secondPage">
            <m_navbar @close="close"/>
        </mt-popup>
    </div>
</template>

<script>
import m_navbar from './m_navbar'
export default {
    name: 'm_newsdetail',
    components: {
        m_navbar
    },
    data: function () {
        return {
            navbarShow: false,
            newsDetail: [],
            from: ''
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
        back () {
            if(this.from == 'm_newslist'){
                this.$router.push('/m_page/m_detailpage/m_newslist')
            }else {
                this.$router.push({
                    path: '/m_page/m_mainpage',
                    query: {
                        to: 1
                    }
                })
            }
        },
        showNavBar () {
            this.navbarShow = true
            },
        close () {
            this.navbarShow = false
        },
        toDetail(item) {
            window.open(item)
        },
        getNewsDetail(id,lang='cn') {
        this.$utils
            .get("portal/api/getNews", {
                lang: lang,
                id: id
            })
            .then(res => {
                this.newsDetail = res.data.data.article
            });
        }
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          this.getNewsList()
      }
    },
    mounted() {
        let newsId = this.$route.query.id
        if(this.$route.query.from == 'm_newslist'){
            this.from = 'm_newslist'
        }
        this.getNewsDetail(newsId)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 0.22rem;
            margin: 0 0.3rem 0 0.54rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        width: 100%;
        background-color: #fff;
        height: calc(100% - 1.4rem);
        overflow: hidden;
        .scrollCon {
            height: 100%;
            
            overflow-y: auto;
            .newsTitle {
                font-size: 0.41rem;
                color: #282828;
                line-height: 0.45rem;
                font-weight: bold;
                text-align: center;
                margin: 0.44rem 0;
                padding: 0 0.6rem;
                line-height: 1.2;
            }
            .newsTimeCon {
                margin-left: 0.39rem;
                padding-bottom: 0.29rem;
                border-bottom: 1px solid #ccc;
                box-sizing: border-box;
                span {
                    color: #999;
                    font-size: 0.2rem;
                    
                    
                }
            }
            .newsContent {
                padding: 0.51rem;
                font-size: 0.24rem;
                color: #282828;
                line-height: 2;
                /deep/ p {
                    font-size: 0.18rem;
                    color: #282828;
                    line-height: 2;
                    margin: 0.1rem auto;
                    text-indent: 2em;
                    strong {
                        font-weight: bold;
                        margin-left: -2em;
                    }
                    img {
                        width: 100%;
                        margin-left: -2em;
                    }
                }

                /deep/ video {
                    display: block;
                    width: 100%;
                    
                    margin: 0 auto;
                }
            }

        }



    }
}
.secondPage {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-image: url(../img/m/m_bg.png);
    background-size: cover;
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
